import React, { useEffect, useState } from "react";
import { Col, Dropdown, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { CardItem } from "../../common/Card/Card";
import Pagination from "../../common/Pagination";
import SelectSeason from "../../common/SelectSeason";
import Tab, { PanelItem } from "../../common/Tab";
import CssLoader from '../../components/cssloader/CssLoader';
import { CalendarIcon } from "../../components/Icons";
import { apiGet } from "../../services/Api";
import { MagazineItem, MagazineResponse } from "../../helpers/interfaces/news";
import Advertising from "../../common/Advertising";
import moment from "moment";
import 'moment/locale/it';
import './blog.css';
import PageMeta from "../../components/PageMeta";

type MagazineType = 'men' | 'women';

type Props = {
    type: MagazineType;
};

export default function MagazinePage(props: Props) {
    const [isMount, setIsMount] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [magazineData, setMagazineData] = useState<MagazineResponse>({});
    const [years, setYears] = useState<string[]>([]);
    const [magazineCards, setMagazineCards] = useState<CardItem[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isShown, setIsShown] = useState<boolean>(false);
    const [currentSeason, setCurrentSeason] = useState<string>("");
    const [activeTab, setActiveTab] = useState<string>('men');

    const pageLimit = 12;
    const pageNeighbours = 5;

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const hash = location.hash.replace("#", "");
        const initialType = hash === "femminile" ? 'women' : 'men';
        (async () => {
            if (!isMount) {
                await changeHandler(initialType === "women" ? 1 : 0)
                await getMagazineData(initialType);
                setIsMount(true);
            }
        })();

        if (initialType !== activeTab) {
            setActiveTab(initialType);
            getMagazineData(initialType);
        }
    }, [activeTab, changeHandler, getMagazineData, isMount, location.hash]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    async function getMagazineData(type: MagazineType) {
        const apiType = type === 'men' ? 'Maschili' : 'Femminili'

        setIsLoading(true);

        apiGet<MagazineResponse, any>('?op=magazine&tipo=pubblicazioni' + apiType).then(async (
            data: MagazineResponse
        ) => {
            let years = Object.keys(data);
            setYears(years);
            setMagazineData(data);

            const currentSeason = Object.keys(data)[0];
            setCurrentSeason(currentSeason);

            await createYearCards(data, currentSeason);
        }).finally(() => {
            setIsLoading(false);
        })
    }

    async function createYearCards(
        data: MagazineResponse,
        season: string
    ) {
        let magazineCards: CardItem[] = [];

        magazineCards = data[season].map((
            item: MagazineItem,
            index: number,
        ) => {
            return {
                id: index,
                title: "Numero " + item.numero,
                content: item.name,
                image: item.img,
                link: item.link,
                linkTitle: item.name
            }
        })

        setMagazineCards(magazineCards);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    async function changeHandler(index: number) {
        if (index === 0) {
            setActiveTab('men');
            getMagazineData('men');
            navigate('/articoli/magazine#maschile', { replace: true });
        } else if (index === 1) {
            setActiveTab('women');
            getMagazineData('women');
            navigate('/articoli/magazine#femminile', { replace: true });
        }
        setCurrentPage(1);
    }

    const paginationCards = [...magazineCards].splice(
        ((currentPage - 1) * pageLimit),
        pageLimit
    );

    const MagazineCard = (props: { id: string, cards: CardItem[] }) => {
        return (
            <Row className="content-width">
                {props.cards.map((card, index) => (
                    <React.Fragment key={index}>
                        {index % 6 === 0 && index !== 0 && (
                            <Advertising code="banner-cat4" as="div" className='text-center py-4' />
                        )}
                        <Col key={`${props.id}_${index}`} md={4}>

                            {card.link ? (
                                <a
                                    href={card.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    title={card.linkTitle}
                                >
                                    <div className="newspapers-number">{card.title}</div>
                                    <img src={card.image} alt="Magazine Cover" className="newspapers" />
                                </a>
                            ) : (
                                <img src={card.image} alt="Magazine Cover" className="newspapers" />
                            )}
                        </Col>
                    </React.Fragment>
                ))}
            </Row>
        );
    };

    const panels: PanelItem[] = [
        {
            id: 'men',
            name: 'Maschile',
            element: <>
                <h2>Pubblicazioni Maschili</h2>
                <MagazineCard id="tab_maschile" cards={paginationCards} />
            </>,
        },
        {
            id: 'women',
            name: 'Femminile',
            element: <>
                <h2>Pubblicazioni Femminili</h2>
                <MagazineCard id="tab_femminile" cards={paginationCards} />
            </>
        }
    ];

    const handleSeasonChange = async (season: string) => {
        if (currentSeason === season) { return; }
        setCurrentSeason(season);
        setIsShown(false);
        await createYearCards(magazineData, season);
    }

    return (
        <React.Fragment>
            <PageMeta
                title="Magazine - Calcio a 5 Live"
                description=""
                image=""
                url={document.location.href}
                type=""
            />
            <div id="blog">
                <div className="">
                    <div className="row justify-content-start magazine-no-wrap">
                        <div className="col-md-3 col-12">
                            <h1 className='calendarDropdown'>Magazine</h1>
                        </div>
                        <div className="col-md-9 col-12">
                            <Dropdown id="calendarDropdown" show={isShown} onToggle={(isOpen, _metadata) => setIsShown(isOpen)} className='calendarDropdown'>
                                {
                                    !isShown ?
                                        <>
                                            <Dropdown.Toggle as="div" className="calendar-toggle" id="date-dropdown">
                                                <CalendarIcon />
                                            </Dropdown.Toggle>

                                            <p className="calendar-tag">{currentSeason}</p>
                                        </>
                                        : <button className="close-btn" onClick={() => setIsShown(false)}>×</button>
                                }
                                <Dropdown.Menu className="dropdown-menu p-0">
                                    <div className="calendar-dropdown">
                                        <SelectSeason
                                            seasons={years}
                                            onSeasonChange={handleSeasonChange}
                                            currentSeason={currentSeason}
                                        />
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>


                <div className="magazine-tabs">
                    <Tab
                        id="magazine_tabs"
                        panels={panels}
                        activeKey={activeTab}
                        onChange={changeHandler}
                        showSidebar
                    />
                </div>

                <div className="py-3">
                    <Pagination
                        totalRecords={magazineCards.length}
                        pageLimit={pageLimit}
                        pageNeighbours={pageNeighbours}
                        currentPage={currentPage}
                        onPageChanged={(value: any) => { setCurrentPage(value) }}
                    />
                </div>

                <CssLoader active={isLoading} text='Caricamento del magazine in corso...' />
            </div>
        </React.Fragment>
    );
}
